<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Other Configurations</h1>
      <v-card :disabled="!onEdit">
        <v-card-title>
          <!-- <span class="body-2">Personnel Movement Entry</span> -->
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col :class="classPadding" xs="12" sm="12" md="12">
              <v-checkbox
                label="Validate Consecutive PME Entry"
                v-model="config.validatePMEEntry"
              ></v-checkbox>
              <span class="body-2">
                <b>If Checked</b> - Will validate all entry when submitting PME.
              </span>
              <br />
              <span class="body-2">
                <b>If Unchecked</b> - Will not validate PME Entry.
              </span>
            </v-col>

            <v-col :class="classPadding" xs="12" sm="12" md="12">
              <v-checkbox
                label="Require Date Issued and Ref No in Bank Account (Import Masterfile)"
                v-model="config.isRequiredBankAccountDateIssuedRefNo"
              ></v-checkbox>
              <span class="body-2">
                <b>If Checked</b> - Will validate required field(s).
              </span>
              <br />
              <span class="body-2">
                <b>If Unchecked</b> - Will not validate required field(s).
              </span>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col :class="classPadding" xs="12" sm="6" md="4">
              <v-text-field
                label="Maximum Employee Per Batch"
                v-model="config.maxEmployeePerBatch"
                type="number"
                autocomplete="off"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col :class="classPadding" xs="12" sm="6" md="4">
              <v-text-field
                label="Logo Width"
                v-model="config.logoWidth"
                type="number"
                autocomplete="off"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-alert
            border="left"
            colored-border
            color="deep-purple accent-4"
            elevation="1"
          >
            Below Logo config is use to Excel report, For Circular logo please
            use the same width and height
          </v-alert>
          <v-row>
            <v-col :class="classPadding" xs="12" sm="6" md="4">
              <v-text-field
                label="Logo XLS Width"
                v-model="config.logoXLSWidth"
                type="number"
                autocomplete="off"
              ></v-text-field>
            </v-col>
            <v-col :class="classPadding" xs="12" sm="6" md="4">
              <v-text-field
                label="Logo XLS Height"
                v-model="config.logoXLSHeight"
                type="number"
                autocomplete="off"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col :class="classPadding" xs="12" sm="6" md="6">
              <v-text-field
                label="TKS Image Path"
                v-model="config.tksPhotoPath"
                autocomplete="off"
              ></v-text-field>
            </v-col>
            <v-col :class="classPadding" xs="12" sm="6" md="6">
              <v-text-field
                label="Payroll Image Path"
                v-model="config.payPhotoPath"
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col :class="classPadding" xs="12" sm="6" md="6">
              <v-text-field
                label="Payroll Database"
                hint="for synchronization of employee information"
                v-model="config.payrollDB"
                autocomplete="off"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col :class="classPadding" xs="12" sm="6" md="4">
              <v-text-field
                label="Minimum Password Age (Day)"
                v-model="config.minimumPasswordAge"
                type="number"
                autocomplete="off"
                min="0"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-row>
        <v-col>
          <v-btn color="info" class="ma-2" @click.stop="edit" :disabled="onEdit"
            >edit</v-btn
          >
          <v-btn
            color="success"
            class="ma-2"
            :disabled="!onEdit"
            :loading="isUpdating"
            @click.stop="update"
            v-if="userAccess.update >= 1 || userAccess.add >= 1"
            >Update</v-btn
          >
          <v-btn
            class="ma-2"
            :disabled="!onEdit"
            @click.stop="
              onEdit = false;
              isUpdating = false;
            "
            >Cancel</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import isEmpty from "lodash/isEmpty";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/otherConfig";
export default {
  metaInfo: {
    title: "Other Configuration",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  mixins: [userAccessMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    onEdit: false,
    isUpdating: false,
    config: {},
  }),
  methods: {
    ...mapActions("otherConfig", ["getConfig"]),
    edit() {
      this.onEdit = true;
    },
    update() {
      this.isUpdating = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.config)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.getConfig();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
  },
  computed: {
    ...mapState("otherConfig", {
      otherConfig: (state) => state.config,
    }),
  },
  created() {
    this.getConfig();

    this.getUserAccessRights("OtherCon");
  },
  watch: {
    otherConfig(val) {
      if (!isEmpty(val)) {
        this.config = val;
      }
    },
  },
};
</script>
